import {Props} from './model';
import {PollStatus, PollType} from '../../../../shared/models/poll';
import {Button} from '../../../../shared/components/button';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../shared/routing';

export default ({poll, style}: Props) => {
  const nav = useNavigation();
  const styles = useStyles(({theme}) => ({
    button: {
      minWidth: 150,
      width: 'auto',
      paddingHorizontal: 2.5,
    },
    buttonText: theme.fonts.h6Light,
    buttonTextActive: theme.fonts.h6Light,
  }));
  if (poll.typeId === PollType.Survey && !poll.isPassed && poll.statusId === PollStatus.Completed) {
    return null;
  }
  return poll.isPassed || poll.statusId === PollStatus.Completed ? (
    <Button
      id='poll-results'
      onPress={() => {
        nav.navigate(poll.typeId === PollType.Voting ? Screens.PollsTypeVoteForm : Screens.PollsTypeSurveyForm, {
          pollId: poll.id,
        });
      }}
      style={[styles.button, style]}
      text={poll.typeId === PollType.Voting ? 'Результаты' : 'Ознакомиться'}
      textStyle={styles.buttonText}
      type='secondary'
    />
  ) : (
    <Button
      id='poll-part'
      onPress={() => {
        nav.navigate(poll.typeId === PollType.Voting ? Screens.PollsTypeVoteForm : Screens.PollsTypeSurveyForm, {
          pollId: poll.id,
        });
      }}
      textStyle={styles.buttonTextActive}
      style={[styles.button, style]}
      text='Участвовать'
      type='primary'
    />
  );
};
